import { BasePage as CngBasePage } from 'cng-web-lib'
import React from 'react'
import useBreadcrumbNameMap from 'src/navigations/breadcrumbs/Breadcrumb_EcommerceUpload'
import TranslationText from './TranslatedText'
import UploadPage from './UploadPage'


//* Module Title ---------------------------------------------------------------
function ModuleTitle() {
      const translatedTextsObject = TranslationText();
      return translatedTextsObject.moduleTitle;
}

function WrappedUploadPage(props) {
      const breadcrumbNameMap = useBreadcrumbNameMap()
      return (
            <CngBasePage
                  moduleTitle={ModuleTitle()}
                  renderPage={(showSnackbar) => (
                        <UploadPage showNotification={showSnackbar} {...props} />
                  )}
                  extraCngBreadcrumbNameMap={breadcrumbNameMap}
            />
      )
}

export {
      WrappedUploadPage as UploadPage
}